export * from './endpoints';
import { generatedAPI } from './endpoints';

export const sandboxSettingsAPI = generatedAPI.enhanceEndpoints({});
